import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { GTypeCat } from 'src/app/services/data/data.service';
import { LocationStoreService } from '../location-store/location-store.service';

@Injectable({
  providedIn: 'root',
})
export class GenericTypeStoreService {
  public genericTypes$: BehaviorSubject<any> = new BehaviorSubject([]);
  public genericTypes = [];
  public severityList = [];
  public defectTypeList = [];

  constructor(private locationStore: LocationStoreService) {}

  set setGenericTypes(data) {
    this.genericTypes$.next(data);
    this.genericTypes = data;
    this.severityList = data.filter(({ category }) => category === 'severity');
    this.defectTypeList = data.filter(
      ({ category }) => category === 'annotation'
    );
  }

  set pushGenericTypes(data) {
    this.genericTypes$.next([...this.locationStore.locations$.getValue(), data]); // need to point location after finished
    this.genericTypes.push(data);
  }

  set popGenericTypes(id) {
    const oldData = this.genericTypes$.getValue();
    const newData = oldData.filter((i) => i.id !== id);
    this.genericTypes$.next(newData);
    this.genericTypes = newData;
  }

  getGenericType(category: GTypeCat, id?, column_name?, raw?) {
    const gTypeByCat = this._reformatGenericTypeByCat(this.genericTypes, !raw)[category]

    if (id && column_name) return gTypeByCat[id][column_name]
    if (id) return gTypeByCat[id]

    return gTypeByCat
  }

  _reformatGenericTypeByCat(data, indexedWithId?) {
    const newData = []
    data.forEach((elem) => {
      if (newData[elem.category] === undefined) {
        newData[elem.category] = [];
      }
      if (indexedWithId)
        newData[elem.category][elem.id] = { ...elem };
      else
        newData[elem.category].push(elem)
    })
    return newData
  }

  clearDataService() {
    this.genericTypes$ = new BehaviorSubject([]);
  }
}
